export enum MandateBulkUploadType {
    MandatesOnly,
    AllDocuments
}
  